import { render } from "./BlockerListIndex.vue?vue&type=template&id=2467abae"
import script from "./BlockerListIndex.vue?vue&type=script&lang=js"
export * from "./BlockerListIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__